// blogIndex.js - Contains only metadata for all blog posts
import Blog1 from "@/assets/images/blog/DDoS-Provider-Website-Seized.jpg";
import Blog2 from "@/assets/images/blog/Understanding DDoS Attacks and How to Protect Your Network.png";
import Blog3 from "@/assets/images/blog/software_development-blog-banner.webp";
import Blog4 from "@/assets/images/blog/OIP.jpg";
import Blog5 from "@/assets/images/blog/Why Investing in Web and Mobile Applications is Essential for Business Growth.jpeg";
import Blog6 from "@/assets/images/blog/seo.jpg";

export const blogIndex = [
    {
        id: 1,
        slug: "authorities-seize-websites-of-ddos-attack-service-providers",
        title: "Authorities Seize Websites of DDoS Attack Service Providers",
        date: "December 21, 2024",
        category: "Cyber Security",
        image: Blog1,
        description: "In a coordinated international effort, authorities have launched a major crackdown on cybercrime, resulting in the arrest of two suspects and the seizure of online platforms used for narcotics trafficking and DDoS attacks.",
        author: "Security Team",
        readTime: "5 min read",
        tags: ["Cybercrime", "DDoS", "Law Enforcement", "Security"],
        contentFile: "AuthoritiesSeizeDDoSWebsites"
    },
    {
        id: 2,
        slug: "battling-the-rising-tide-understanding-ddos-attacks-and-how-to-protect-your-network",
        title: "Battling the Rising Tide: Understanding DDoS Attacks and How to Protect Your Network",
        date: "December 21, 2024",
        category: "Cyber Security",
        image: Blog2,
        description: "In today's hyper-connected world, businesses and individuals alike are increasingly vulnerable to a variety of cyber threats. One of the most notorious and damaging forms of cyberattack is the Distributed Denial of Service (DDoS) attack.",
        author: "Security Team",
        readTime: "7 min read",
        tags: ["Cybercrime", "IT Infrastructure Management"],
        contentFile: "BattlingRisingTide"
    },
    {
        id: 3,
        slug: "exciting-developments-at-san-micron-innovating-through-web-and-software-solutions",
        title: "Exciting Developments at SAN micron: Innovating Through Web and Software Solutions",
        date: "December 21, 2024",
        category: "Software Development",
        image: Blog3,
        description: "At SAN micron, we are committed to pushing the boundaries of technology to deliver exceptional web and software solutions.",
        author: "Admin",
        readTime: "8 min read",
        tags: ["Software Development"],
        contentFile: "InnovatingThroughWebandSoftwareSolutions"
    },
    {
        id: 4,
        slug: "unlocking-your-online-presence-the-importance-of-domain-registration-and-web-hosting",
        title: "Unlocking Your Online Presence: The Importance of Domain Registration and Web Hosting",
        date: "December 21, 2024",
        category: "Website Development",
        image: Blog4,
        description: "In today's digital landscape, establishing a strong online presence is essential for businesses and individuals alike.",
        author: "Development Team",
        readTime: "6 min read",
        tags: ["Website Development"],
        contentFile: "ImportanceOfDomainRegistrationandWebHosting"
    },
    {
        id: 5,
        slug: "why-investing-in-web-and-mobile-applications-is-essential-for-business-growth",
        title: "Why Investing in Web and Mobile Applications is Essential for Business Growth",
        date: "December 21, 2024",
        category: "Software Development",
        image: Blog5,
        description: "In an increasingly digital world, businesses must adapt to meet the demands of their customers.",
        author: "Admin",
        readTime: "9 min read",
        tags: ["Software Development"],
        contentFile: "WhyInvestingInWebandMobileApplications" 
    },
    {
        id: 6,
        slug: "seo-the-silent-engine-driving-business-growth",
        title: "SEO: The Silent Engine Driving Business Growth",
        date: "June 01, 2026",
        category: "SEO",
        image: Blog6,
        description: "In an increasingly digital world, businesses must adapt to meet the demands of their customers.",
        author: "Admin",
        readTime: "12 min read",
        tags: ["SEO", "Digital Marketing", "Artificial Intelligence", "Business Growth", "Content Strategy", "Local SEO", " E-Commerce"],
        contentFile: "SEOTheSilentEngineDrivingBusinessGrowth" 
    }
];

// Get post metadata by slug
export const getPostBySlug = (slug) => {
    return blogIndex.find(post => post.slug === slug);
};

// Get related posts
export const getRelatedPosts = (currentPost, limit = 3) => {
    return blogIndex
        .filter(post => post.id !== currentPost.id && post.category === currentPost.category)
        .slice(0, limit);
};

// Get all unique categories
export const getCategories = () => {
    const categorySet = new Set(blogIndex.map(post => post.category));
    return ["All", ...Array.from(categorySet)];
};

// Get all posts, newest first (id 6, 5, 4, 3, 2, 1)
export const getAllPosts = () => {
    return [...blogIndex].reverse();
};